var _defs, _path, _use, _use2, _use3, _use4, _use5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCn = function SvgCn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cn_svg__a",
    fill: "#ff0",
    d: "M1-.3-.7.8 0-1 .6.8-1-.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ee1c25",
    d: "M0 0h512v512H0z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn_svg__a",
    width: 30,
    height: 20,
    transform: "translate(128 128)scale(76.8)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn_svg__a",
    width: 30,
    height: 20,
    transform: "rotate(-121 142.6 -47)scale(25.5827)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn_svg__a",
    width: 30,
    height: 20,
    transform: "rotate(-98.1 198 -82)scale(25.6)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn_svg__a",
    width: 30,
    height: 20,
    transform: "rotate(-74 272.4 -114)scale(25.6137)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn_svg__a",
    width: 30,
    height: 20,
    transform: "matrix(16 -19.968 19.968 16 256 230.4)"
  })));
};
export default SvgCn;